<img [src]="src" class="avatar-icon" [style.width]="size" [style.height]="size" *ngIf="src" />

<span class="mat-background-{{i}} mat-color-{{i}}-contrast avatar-icon" [style.width]="size" [style.height]="size" [style.font-size.px]="parsedSize" [ngClass]="{ 'square': squareMode }" *ngIf="letter && !src">
  {{letter}}
</span>